import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || "",
    user: null,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    },
    LOGOUT(state) {
      state.token = "";
      state.user = null;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      delete axios.defaults.headers.common["Authorization"];
      window.location.reload();
    },
    SET_USER(state, user) {
      state.user = user;
      const stringifyUser = JSON.stringify(user);
      localStorage.setItem("user", stringifyUser);
    },
    LOAD_USER_FROM_LOCAL_STORAGE(state) {
      const user = localStorage.getItem("user");
      if (user) {
        state.user = JSON.parse(user);
      } else {
        state.user = null;
      }
    },
  },
  actions: {
    async login({ commit }, { username, password }) {
      try {
        const { data } = await axios.post("/api/login", { username, password });
        commit("SET_TOKEN", data.token);
        commit("SET_USER", data.user);
        return true;
      } catch (error) {
        throw error.response.data.message || "Login failed";
      }
    },

    loadUserFromLocalStorage({ commit }) {
      commit("LOAD_USER_FROM_LOCAL_STORAGE");
    },

    logout({ commit }) {
      commit("LOGOUT");
    },

    initializeStore({ commit }) {
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user");

      if (token && user) {
        commit("SET_USER", JSON.parse(user));
      }
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    isRootUser: (state) => state.user && state.user.role === 0,
  },
});
